import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { BaseSchema } from 'yup';
import { PASSWORD_REGEX } from 'settings/regex';

export default (isUk: boolean, t: TFunction): BaseSchema =>
  Yup.object().shape({
    password: Yup.string().required(t('LABEL_ERROR_PASSWORD_REQUIRED')),
    newPassword: Yup.string()
      .required(' ')
      .max(32, t('LABEL_ERROR_PASSWORD_MAX'))
      .matches(PASSWORD_REGEX, ' '),
    confirmNewPassword: Yup.string()
      .required(
        t('LABEL_ERROR_CONFIRM_NEW_PASSWORD_NOT_SAME', { ns: 'translation' })
      )
      .oneOf(
        [Yup.ref('newPassword'), null],
        t('LABEL_ERROR_CONFIRM_NEW_PASSWORD_NOT_SAME', { ns: 'translation' })
      ),
  });
